import React from 'react'

import type { IconProps } from './types'

const TikiArrow: React.FC<IconProps> = ({ size = 40, color, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_2752_36921)">
        <path
          d="M9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z"
          fill="white"
        />
        <path
          d="M13.7471 8.95891L6.15026 4.31869L7.3719 13.2062L9.43129 11.3099L11.3285 14.1674L13.0635 13.0177L11.1535 10.1426L13.7471 8.95891Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2752_36921">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TikiArrow
